import {useDispatch} from "react-redux";

import {
  getOptionsData,
  getListData,
  getCashiersData,
  getCurrenciesData,
  getBrandsData,
  getPlatformsData,
  clearDownload,
  clearListState,
  clearColumnsState,
  clearCashiersState,
  reset,
} from "./index";

export const useCashierStatisticReport = () => {
  const dispatch = useDispatch();

  const getOptions = (data: any) => dispatch(getOptionsData(data));
  const getList = (data: any) => dispatch(getListData(data));
  const getCashiers = (data: any) => dispatch(getCashiersData(data));
  const getCurrencies = (data: any) => dispatch(getCurrenciesData(data));
  const getBrands = (data: any) => dispatch(getBrandsData(data));
  const getPlatforms = (data: any) => dispatch(getPlatformsData(data));
  const clearListData = () => dispatch(clearListState());
  const resetState = () => dispatch(reset());
  const clearDownloadState = () => dispatch(clearDownload());
  const clearColumns = () => dispatch(clearColumnsState());
  const clearCashiers = () => dispatch(clearCashiersState());

  return {
    getOptions,
    getList,
    clearDownloadState,
    clearListData,
    resetState,
    getCashiers,
    getCurrencies,
    getBrands,
    getPlatforms,
    clearColumns,
    clearCashiers,
  }
}
